export type { DialogProps, DialogActions, DialogChildren } from './Dialog.types'
export { default as Dialog } from './Dialog'